const buttons = document.querySelectorAll('.sidebar__accordion__button');

buttons.forEach((button) => {
    button.controls = document.getElementById(button.getAttribute('aria-controls'));

    button.addEventListener('click', (e) => {
        if (button.getAttribute('aria-expanded') === 'true') {
            button.setAttribute('aria-expanded', 'false');
            button.controls.classList.remove('sidebar__accordion__content--expanded');
        }
        else {
            button.setAttribute('aria-expanded', 'true');
            button.controls.classList.add('sidebar__accordion__content--expanded');
        }
    });
});